import { render, staticRenderFns } from "./TerminationModal.vue?vue&type=template&id=321a2891&scoped=true&"
import script from "./TerminationModal.vue?vue&type=script&lang=ts&"
export * from "./TerminationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321a2891",
  null
  
)

export default component.exports